import { createAsyncThunk } from '@reduxjs/toolkit';
import { OpportunitiesTableFilter } from '../../../../components/Table/models/table-filter';
import { objectToQueryString } from '../../../../utils/queryHelper';
import createNotification from '../../../../utils/createNotification';

export const GetOpportunities = createAsyncThunk(
    'marketplace/getOpportunities',
    async (filterParams: OpportunitiesTableFilter, dispatch: any) => {
        const axios = dispatch.getState().core.axios;
        const queryString = objectToQueryString(filterParams);

        try {
            const response = await axios.get(
                `/api/Marketplace/MarketplaceOpportunities?${queryString}`
            );

            if (response.status !== 200) {
                throw new Error('Failed to fetch opportunities');
            }

            return {
                opportunities: response.data.list,
                pageNumber: response.data.pageNumber,
                totalItems: response.data.totalItems,
                pageSize: response.data.pageSize,
            };
        } catch (error) {
            createNotification(
                'An error occurred while fetching opportunities.',
                'error'
            );
            throw error;
        }
    }
);
